import styled from 'styled-components'

export const MenuWrapper = styled.div`
  padding: 8px 0 16px;
`

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`

export const SettingWrapper = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
`

export const BasicSettingWrapper = styled.div`
  width: 320px;
  padding: 24px;
  border-right: 1px solid rgba(0,0,0,.1);
`

export const CustomSettingWrapper = styled.div`
  width: calc(100% - 320px);
  padding: 24px;

  .ant-empty-description {
    color: rgba(0,0,0,.3);
  }
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`

export const SegmentLeft = styled.div`
  width: 45%;
  padding-bottom: 16px;

  .noExpand .ant-tree-switcher-noop {
    width: 4px;
  }
`

export const SegmentRight = styled.div`
  width: 55%;
  padding: 8px 0px 0px 16px;

  .add-btn {
    width: 100%;
    margin-top: 24px;
  }
`

const showScroll = `
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 9px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .1);
  }
`

export const TreeWrapper = styled.div`
  overflow-y: scroll;
  max-height: 60vh;
  ${showScroll}
  .selectIcon {
    color: var(--primary);
    margin-left: 4px;
    font-size: 14px;
    cursor: pointer;
  }
`

export const SectionWrapper = styled.div`
  overflow-y: scroll;
  max-height: 60vh;
  padding-right: 8px;
  ${showScroll}
`

export const Section = styled.div`
  border: 1px solid ${({ active }) => active ? 'var(--primary)' : 'rgba(0,0,0,.1)'};
  min-height: 150px;
  cursor: pointer;
  margin-bottom: 20px;
`

export const ListHeader = styled.div`
  width: 50%;
  text-align: center;
  padding: 8px 0px;
  line-height: 16px;
  border-bottom: 1px solid rgba(0,0,0,.1);
  cursor: pointer;
  &:hover {
    background: rgba(0,0,0,.05);
  }
  &:first-child {
    border-right: 1px solid rgba(0,0,0,.1);
  }

  ${({ active }) => active ? 'background: rgba(0,0,0,.05); font-weight: 600;' : ''}
`

export const ListWrapper = styled.div`
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
  min-height: calc(100% - ${({ withHeader }) => withHeader ? '32px' : '0px'});
`

export const List = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 8px;
  cursor: pointer;
  .txt {
    word-spacing: 4px;
    cursor: pointer;
  }
  .btn {
    cursor: pointer;
  }

  &:hover {
    background: rgba(0,0,0,.05);
  }
`

export const CriteriaWrapper = styled.div`
  margin: 0px 0px 24px;
`

export const CriteriaTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  padding-bottom: 12px;
`

export const LogicTitle = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 500;
  padding-bottom: 8px;
`

export const Line = styled.span`
  height: 1px;
  background: rgba(0,0,0,.1);
  width: calc(100% - ${({ small }) => small ? '100px' : '80px'});
  margin: auto 0px;
`

export const HorizontalFormWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  > div {
    flex-basis: 0;
    flex-grow: 1;
  }
  
  .ant-form-item {
    margin-bottom: 0px;
  }
`

export const LocationSelectionWrapper = styled.div`
  display: flex;
  .ant-form-item {
    margin-bottom: 0px;
  }
  @media(max-width: 1100px) { 
    flex-direction: column;
  }
`

const mapHeight = '480px'
const selectorBoxHeight = `calc(${mapHeight} - 32px - 12px - 26px)` // 32: selector height, 12: margin of option box, 26: title height
export const MapWrapper = styled.div`
  width: 40%;

  .leaflet-container {
    height: ${mapHeight};
  }
  .leaflet-control-attribution {
    display: none;
  }

  @media(max-width: 1100px) { 
    width: 100%;
  }
`

export const SelectorWrapper = styled.div`
  width: calc(60% - 16px);
  margin-left: 16px;
  @media(max-width: 1100px) { 
    width: 100%;
    margin: 16px 0px;
  }
`

export const OptionsWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const OptionsBox = styled.div`
  margin-top: 12px;
  width: 50%;
  .title {
    padding-bottom: 4px;
  }
`

export const Box = styled.div`
  border: 1px solid rgba(0,0,0,.1);
  height: ${selectorBoxHeight};
  overflow-y: auto;
  padding: 4px 0px;
  
  .ant-checkbox-group {
    flex-direction: column;
    width: 100%;
  }
  .ant-checkbox-wrapper {
    padding: 4px 8px;
    width: 100%;
    &:hover {
      background: rgba(0,0,0,.04);
    }
  }
  .ant-checkbox-wrapper+.ant-checkbox-wrapper {
    margin-inline-start: 0px;
  }
`

export const OverflowSpin = styled.div`
  position: absolute;
  background: rgba(255,255,255,.7);
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  z-index: 999;
  display: flex;
  justify-content: center;
  padding-top: 80px;
`

export const BasicInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-statistic .ant-statistic-title {
    margin-bottom: 0px;
    color: rgba(0,0,0,.3)
  }
  .ant-statistic .ant-statistic-content {
    color: #000;
    font-size: 14px;
  }
`

export const CriteriaInfo = styled.div`
  ${({ modalMode }) => modalMode ? 'padding: 8px 0px 16px;' : 'padding-bottom: 32px;'}
  display: flex;
  flex-direction: column;
  ${({ modalMode }) => modalMode ? 'gap: 4px;' : 'gap: 10px;'};
`

export const CriteriaInfoTitle = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 500;
  border-bottom: 1px solid black;
  width: fit-content;
`

export const UnderlineBoldTxt = styled.div`
  font-weight: 500;
  border-bottom: 1px solid #000;
  line-height: 18px;
  margin-bottom: 8px;
  width: fit-content;
`

export const RoundTag = styled.span`
  font-size: 13px;
  color: #fff;
  background-color: var(--primary);
  border-radius: 12px;
  padding: 2px 10px;
  margin-left: 6px;
`

export const SegmentInfoWrapper = styled.div`
  ${({ detailOnly }) => detailOnly ? '' : 'display: flex;'}
  flex-wrap: wrap;
`

export const SegmentInfo = styled.div`
  ${({ detailOnly }) => detailOnly ? 'padding: 8px 0px 10px;' : 'padding-bottom: 32px;'}
  display: flex;
  flex-direction: column;
  word-spacing: 2px;
  ${({ detailOnly }) => detailOnly ? 'gap: 4px;' : 'gap: 10px;'};
  flex-grow: 1;
  flex-basis: 50%;
  &:after {
    content: "";
    flex: auto;
  }
`

export const SegmentInfoTitle = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 500;
  border-bottom: 1px solid black;
  width: fit-content;
`
